import { getAuthContext } from '../context/AuthContext';

const getAxios = () => getAuthContext().axiosInstance;

export const VentaService = {
    getAll: async () => {
        const response = await getAxios().get('/api/ventas');
        return response.data;
    },
    
    getByCodigo: async (codigo) => {
        const response = await getAxios().get(`/api/ventas/codigo/${codigo}`);
        return response.data;
    },

    create: async (venta) => {
        const response = await getAxios().post('/api/ventas', venta);
        return response.data;
    },

    completar: async (id, datosCompletar) => {
        const response = await getAxios().put(`/api/ventas/${id}/completar`, datosCompletar);
        return response.data;
    },
    
    completarVentaCompleta: async (ventaPayload) => {
        const response = await getAxios().post(`/api/ventas/transaccion`, ventaPayload);
        return response.data;
    },
    
    getReportesDiarios: async (idEmpresa) => {
        const response = await getAxios().get(`/api/ventas/reportes/diarios?idEmpresa=${idEmpresa}`);
        return response.data;
    },
    
    getReportesMensuales: async (idEmpresa) => {
        const response = await getAxios().get(`/api/ventas/reportes/mensuales?idEmpresa=${idEmpresa}`);
        return response.data;
    }
};
